module.exports = __webpack_public_path__ + "img/徐寅生@2x.b58d85b2.png";